import { Tooth } from "../odontogram/odontogram.model";

export class ItemValidators {
  static hasSurfacesSelected(item): boolean {
    return item.options.surfaces && item.options.surfaces.length > 0;
  }

  static hasLocationSelected(item): boolean {
    return item.options.location && item.options.location !== "";
  }

  static hasDegreeSelected(item): boolean {
    return item.options.degree && item.options.degree !== "";
  }

  static hasStatusSelected(item): boolean {
    return item.options.status && item.options.status !== "";
  }

  static hasChannelSelected(item): boolean {
    return item.options.channels && item.options.channels !== "";
  }

  static hasTypeSelected(item): boolean {
    return item.options.type && item.options.type !== "";
  }

  static hasOptionSelected(item): boolean {
    return Array.isArray(item.options.options)
      ? item.options.options.length > 0
      : item.options.options != null;
  }

  static hasOptionObjectSelected(item): boolean {
    return Object.keys(item.options.options).length > 0;
  }

  static hasTeethSelected(item, total = 1): boolean {
    return item.teeth.length >= total;
  }

  static validateCustomTeeth(item, validTeethNumbers: number[]) {
    const valid =
      item.teeth.filter(
        (toothNumber) => validTeethNumbers.indexOf(toothNumber) > -1,
      ).length === item.teeth.length;

    if (!valid) {
      alert("you can only select the following teeth: " + validTeethNumbers);
    }

    return valid;
  }

  static notMissingTeeth(
    item,
    odontogram: Tooth[],
    allowImplant = false,
  ): boolean {
    const valid =
      odontogram.filter(
        (tooth) =>
          item.teeth.indexOf(tooth.number) > -1 &&
          tooth.missing &&
          (!allowImplant || (allowImplant && !tooth.implant)),
      ).length === 0;

    if (!valid) {
      alert("you cannot select a missing teeth");
    }

    return valid;
  }

  static sameJaw(item): boolean {
    const jaw = item.teeth.map((tooth) =>
      Math.floor(tooth / 10) <= 2 ? "upper" : "lower",
    );
    return new Set(jaw).size === 1;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/item-validators.ts